import { render, staticRenderFns } from "./CtcOpportunitiesView.vue?vue&type=template&id=49da3932&scoped=true&"
import script from "./CtcOpportunitiesView.vue?vue&type=script&lang=js&"
export * from "./CtcOpportunitiesView.vue?vue&type=script&lang=js&"
import style0 from "./CtcOpportunitiesView.vue?vue&type=style&index=0&id=49da3932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da3932",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VDataTable,VTooltip})
